import ErrorService from "@/services/errorService";

export const errorHandlerMixin = {
    methods: {
        /**
         * Handle API errors in components
         * @param {Error} error - The error from API call
         * @param {string} customMessage - Optional custom message
         */
        handleApiError(error, customMessage = null) {
            ErrorService.handleError(error, customMessage);
        },

        /**
         * Handle validation errors specifically
         * @param {Object} validationErrors - Validation errors object
         */
        handleValidationErrors(validationErrors) {
            const message =
                ErrorService.handleValidationErrors(validationErrors);
            this.$store.dispatch("toastification/setToast", {
                message: message,
                type: "error",
            });
        },

        /**
         * Show success message
         * @param {string} message - Success message to show
         */
        showSuccess(message) {
            this.$store.dispatch("toastification/setToast", {
                message: message,
                type: "success",
            });
        },

        /**
         * Show warning message
         * @param {string} message - Warning message to show
         */
        showWarning(message) {
            this.$store.dispatch("toastification/setToast", {
                message: message,
                type: "warning",
            });
        },

        /**
         * Show info message
         * @param {string} message - Info message to show
         */
        showInfo(message) {
            this.$store.dispatch("toastification/setToast", {
                message: message,
                type: "info",
            });
        },

        /**
         * Show error message
         * @param {string} message - Error message to show
         */
        showError(message) {
            this.$store.dispatch("toastification/setToast", {
                message: message,
                type: "error",
            });
        },
    },
};
